import { useGet } from '@/query/fetchHooks';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { useEffect, useState, useContext } from 'react';
import {
  PersonAvatar,
  PageHeader,
  Button,
  Tag,
  Tabs,
  InputText,
  FilterList,
  FilterDropdown,
} from '@teo/components';
import { ArrowRight, Search } from '@teo/components/icons';
import { DataTable } from '@/components/DataTable/DataTable';
import {
  parseRole,
  newUid,
  toPercent,
  round2,
  useMobile,
  downloadPDFLink,
} from '@/util.js';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import OptionsAction from '@/components/DataTable/OptionsAction';
import { axios } from '@/axios';
import { config } from '@/config';
import { AuthContext } from '@/components/Contexts/AuthContext';
import i18n from 'i18next';
import { Userwithorganisationwithidps } from '@/models';
import Hint from '@/components/Hints/Hints';
import { HintsContext } from '@/components/Contexts/HintsContext';
import { NavContext } from '@/components/NavContext';
import MobileSubPageMenu from '@/components/HeaderMobile/MobileSubPageMenu';
import ComponentDeleteModal from '@/components/DeleteModal/ComponentDeleteModal';
import { NotificationContext } from '@/components/Contexts/NotificationContext';
import MergeModal from '@/components/MergeModal/MergeModal';
import DownloadReportModal from '../../Organisation/ReportPage/DownloadReportModal';
import ReportDownloadModal from '@/components/ReportDataTable/ReportDownloadModal';
import { BreadCrumbsDetails } from '@/components/BreadCrumbsDetails';
import DeleteModalFollow from '@/components/DeleteModal/DeleteModalFollow';

export interface Filter {
  label: string;
  value: string;
}

function UserDetailsPage({ student, setIsOpenAddContentModal, action }: any) {
  const { userId, organisationId } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isMobile = useMobile();
  const { setSubPage } = useContext(NavContext);
  const { hints } = useContext(HintsContext);
  const { setShowNotification } = useContext(NotificationContext);
  const initialTab = new URLSearchParams(window.location.search).get('tab');
  const [tab, setTab] = useState(
    ['courses', 'learningpaths', 'profiles'].includes(initialTab || '')
      ? initialTab || 'courses'
      : 'courses'
  );
  const [courseInpFilter, setCourseInpFilter] = useState('');
  const [lpInpFilter, setLpInpFilter] = useState('');

  const [resetCourseTable, setResetCourseTable] = useState(newUid(20));
  const [resetLPTable, setResetLPTable] = useState(newUid(20));

  const [filterStatus, setFilterStatus] = useState<any>();
  const [filterLpStatus, setFilterLpStatus] = useState<any>();
  const [coursesType, setCoursesType] = useState<any>();
  const [selectedStatus, setSelectedStatus] = useState<Filter[]>([
    {
      label: t('pages.follow_up_courses.status_active'),
      value: 'active',
    },
  ]);
  const [selectedLpStatus, setSelectedLpStatus] = useState<Filter[]>([
    {
      label: t('pages.follow_up_courses.status_active'),
      value: 'active',
    },
  ]);
  const [isFollow, setIsFollow] = useState(false);

  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);
  const [isOpenDeleteModalCourse, setIsOpenDeleteModalCourse] = useState(false);

  const [itemDelete, setItemDelete] = useState<any>();

  const [isOpenMergeModal, setIsOpenMergeModal] = useState(false);
  const [isMergeActive, setIsMergeActive] = useState(false);
  const [mergeContent, setMergeContent] = useState([]);
  const [mergeCourse, setMergeCourse] = useState(null);
  const [lpDelete, setLpDelete] = useState<any>();
  const [allCourses, setAllCourses] = useState<any[]>([]);
  const [selectedCourses, setSelectedCourses] = useState<Set<string | number>>(
    new Set<string | number>()
  );
  const [deselectCourses, setDeselectCourses] = useState<boolean>(false);

  const { auth } = useContext(AuthContext);
  const authUser = auth?.user as Userwithorganisationwithidps;
  const useCertificates = auth?.user?.useCertificates;

  const [contentRange, setContentRange] = useState(0);

  const basePath = window.location.pathname.slice(
    0,
    window.location.pathname.lastIndexOf('/')
  );

  const [downloadReportPayload, setDownloadReportPayload] = useState<any>(null);
  const [isOpenDownloadtModal, setIsOpenDownloadtModal] = useState(false);

  // single course / learning path report: choose download or send by email
  const [isOpenDownloadReportModal, setIsOpenDownloadtReportModal] =
    useState(false);
  const [payloadDownload, setPayloadDownload] = useState<any>(null);

  const openCourseReportModal = (course: any, payload: any) => {
    setPayloadDownload({
      userIds: [student.id],
      courseId: course.courseId || course.id,
      ...payload,
    });
    setIsOpenDownloadtReportModal(true);
  };

  const openLpReportModal = (learningpath: any, payload: any) => {
    setPayloadDownload({
      userIds: [student.id],
      lpIds: learningpath.lpgroupId,
      ...payload,
    });
    setIsOpenDownloadtReportModal(true);
  };

  useGet(`/trackuserdetails`, {
    organisationId: organisationId,
    userId: auth?.user?.id,
    studentId: userId,
    onSuccess: (result: any) => {
      result && result?.data?.length > 0 && setIsFollow(true);
    },
  });

  useEffect(() => {
    setSubPage(true);
    return () => setSubPage(false);
  }, []);

  useEffect(() => {
    if (student && action) {
      axios.post(config.backend + '/activity', {
        userId: auth?.user?.id,
        subjectId: student.id,
        activityType: 'user',
        subject: student.username,
        link: window.location.pathname,
      });
    }
  }, [student]);

  const FILTERS_STATUS = [
    {
      label: t('pages.follow_up_courses.status_active'),
      value: 'active',
    },
    {
      label: t('pages.follow_up_courses.status_inactive'),
      value: 'disabled,hidden',
    },
  ];

  const coursePath =
    basePath.slice(0, basePath.lastIndexOf('/')) + '/courses/details';

  const lpPath =
    basePath.slice(0, basePath.lastIndexOf('/')) + '/learning-paths/details';
  useEffect(() => {
    if (selectedStatus.length == 0) {
      setFilterStatus(null);
    }
    if (selectedStatus.length == 1) {
      setFilterStatus(`${selectedStatus[0].value}`);
    }
    if (selectedStatus.length > 1) {
      const select = selectedStatus?.map((el) => el.value);
      setFilterStatus(`${select}`);
    }
    setResetCourseTable(newUid(20));
  }, [selectedStatus]);

  useEffect(() => {
    if (selectedLpStatus.length == 0) {
      setFilterLpStatus(null);
    }
    if (selectedLpStatus.length == 1) {
      setFilterLpStatus(`${selectedLpStatus[0].value}`);
    }
    if (selectedLpStatus.length > 1) {
      const select = selectedLpStatus?.map((el) => el.value);
      setFilterLpStatus(`${select}`);
    }
    setResetLPTable(newUid(20));
  }, [selectedLpStatus]);

  useEffect(() => {
    setSelectedCourses(new Set<string | number>());
    setDeselectCourses(false);
  }, [filterStatus, coursesType, userId, organisationId]);

  const followedCoursePath = '/myfollowedmembercourses';

  let followCourseType: any;
  let courseTypeData: any;
  const courseType = authUser?.useCourse;
  const assessmentType = authUser?.useAssessment;
  const vacancyType = authUser?.useLeervacature;

  const caseKey = `${courseType}-${assessmentType}-${vacancyType}`;

  switch (caseKey) {
    case 'false-true-true':
      followCourseType = 'assessment,OR,courseType=leervacature';
      courseTypeData = [
        {
          id: 'assessment',
          name: t('courseTypes.assessment'),
        },
        {
          id: 'leervacature',
          name: t('courseTypes.leervacature'),
        },
      ];
      break;
    case 'true-true-false':
      followCourseType = 'course,OR,courseType=assessment';
      courseTypeData = [
        {
          id: 'course',
          name: t('courseTypes.course'),
        },
        {
          id: 'assessment',
          name: t('courseTypes.assessment'),
        },
      ];
      break;
    case 'true-false-true':
      followCourseType = 'course,OR,courseType=leervacature';
      courseTypeData = [
        {
          id: 'course',
          name: t('courseTypes.course'),
        },
        {
          id: 'leervacature',
          name: t('courseTypes.leervacature'),
        },
      ];
      break;
    case 'true-false-false':
      followCourseType = 'course';
      courseTypeData = [
        {
          id: 'course',
          name: t('courseTypes.course'),
        },
      ];
      break;
    case 'false-true-false':
      followCourseType = 'assessment';
      courseTypeData = [
        {
          id: 'assessment',
          name: t('courseTypes.assessment'),
        },
      ];
      break;
    case 'false-false-true':
      followCourseType = 'leervacature';
      courseTypeData = [
        {
          id: 'leervacature',
          name: t('courseTypes.leervacature'),
        },
      ];
      break;
    default:
      followCourseType =
        'course,OR,courseType=assessment,OR,courseType=leervacature';
      courseTypeData = [
        {
          id: 'course',
          name: t('courseTypes.course'),
        },
        {
          id: 'assessment',
          name: t('courseTypes.assessment'),
        },
        {
          id: 'leervacature',
          name: t('courseTypes.leervacature'),
        },
      ];
      break;
  }

  const followedCourseParams = {
    userId: authUser?.id,
    studentId: userId,
    organisationId: organisationId,
    courseStatus: filterStatus,
    courseType: coursesType ? coursesType?.id : followCourseType,
  };

  useGet(followedCoursePath, {
    ...followedCourseParams,
    onSuccess: (result: any) => {
      setAllCourses(result?.data || []);
    },
  });

  const getSelectedCourseIds = () => {
    const selectedCourseIdList = Array.from(selectedCourses);

    const selectedReportCourseIds = deselectCourses
      ? allCourses
          .filter(
            (course: any) =>
              !selectedCourseIdList.some(
                (selectedCourseId) =>
                  String(course.id) === String(selectedCourseId) ||
                  String(course.courseId) === String(selectedCourseId)
              )
          )
          .map((course: any) => course.courseId || course.id)
      : selectedCourseIdList.map((selectedCourseId) => {
          const selectedCourse = allCourses.find(
            (course: any) =>
              String(course.id) === String(selectedCourseId) ||
              String(course.courseId) === String(selectedCourseId)
          );

          return (
            selectedCourse?.courseId || selectedCourse?.id || selectedCourseId
          );
        });

    return Array.from(new Set(selectedReportCourseIds.filter(Boolean)));
  };

  const openBulkReportModal = (payload: any) => {
    const courseIds = getSelectedCourseIds();

    if (!courseIds?.length || !student?.id) return;

    setDownloadReportPayload({
      lang: i18n.language,
      organisationId,
      userId: student.id,
      courseIds,
      ...payload,
    });

    setIsOpenDownloadtModal(true);
  };

  const bulkReportMenuItems = [
    {
      id: 'bulk-detailed-course-report',
      title: t('report.courseOverviewDetailed'),
      onClick: (ev: any) => {
        ev?.preventDefault?.();
        ev?.stopPropagation?.();

        openBulkReportModal({
          formType: 'courseOverview',
          noCompetences: true,
        });
      },
    },
    {
      id: 'bulk-detailed-competence-report',
      title: t('report.courseOverviewDetailedCompetences'),
      onClick: (ev: any) => {
        ev?.preventDefault?.();
        ev?.stopPropagation?.();

        openBulkReportModal({
          formType: 'courseOverview',
        });
      },
    },
    {
      id: 'bulk-course-report',
      title: t('report.courseOverview'),
      onClick: (ev: any) => {
        ev?.preventDefault?.();
        ev?.stopPropagation?.();

        openBulkReportModal({
          formType: 'courseOverview',
          noBirth: true,
          noDiploma: true,
          noLessons: true,
        });
      },
    },
    {
      id: 'bulk-competence-report',
      title: t('report.courseOverviewCompetences'),
      onClick: (ev: any) => {
        ev?.preventDefault?.();
        ev?.stopPropagation?.();

        openBulkReportModal({
          formType: 'courseOverview',
          noBirth: true,
          noDiploma: true,
          noLessons: true,
        });
      },
    },
    {
      id: 'bulk-certificate',
      title: t('pages.follow_up_courses.download_certificate'),
      onClick: (ev: any) => {
        ev?.preventDefault?.();
        ev?.stopPropagation?.();

        openBulkReportModal({
          formType: 'certificate',
        });
      },
    },
    {
      id: 'bulk-results',
      title: t('pages.follow_up_courses.download_results'),
      onClick: (ev: any) => {
        ev?.preventDefault?.();
        ev?.stopPropagation?.();

        openBulkReportModal({
          formType: 'exportResults',
        });
      },
    },
  ];
  const filteredBulkReportMenuItems = useCertificates
    ? bulkReportMenuItems
    : bulkReportMenuItems.filter((item) => item.id !== 'bulk-certificate');

  if (!student) return null;

  const handleDeleteUser = async (learningpath: any) => {
    await axios.delete(
      `${config.backend}/lpfollow/${learningpath?.lpgroupId}/${student?.userId}`
    );
    setResetLPTable(newUid(20));

    setIsOpenDeleteModal(false);
  };

  const handleCourseMerge = async (course: any) => {
    if (course?.coursecontentId) {
      let coursesM = [];
      let serchId;
      if (course?.learningpathId) {
        serchId = `masterId=${course?.coursecontentId}`;
      } else {
        serchId = `coursecontentId=${course?.coursecontentId}`;
      }
      try {
        const response = await axios.get(
          `${config.backend}${followedCoursePath}?userId=${authUser?.id}&studentId=${userId}&${serchId}&organisationId=${organisationId}&sort=updatedAt`
        );
        coursesM = response?.data
          ?.filter((crs: any) => crs?.id !== course?.id)
          .filter((crs: any) => !crs?.learningpathId);
      } catch (error) {
        console.error('Error fetching courses:', error);
      }
      if (coursesM?.length > 0) {
        setIsMergeActive(true);
        setMergeContent(coursesM);
      } else {
        setIsMergeActive(false);
        setMergeContent([]);
      }
    }
  };

  const compactCourseReportOptions = (course: any) => ({
    noBirth:
      (course?.courseType === 'course' ||
        course?.courseType === 'assessment') &&
      true,
    noDiploma:
      (course?.courseType === 'course' ||
        course?.courseType === 'assessment') &&
      true,
    noLessons:
      (course?.courseType === 'course' ||
        course?.courseType === 'assessment') &&
      true,
  });

  const deleteCourse = async (course: any) => {
    await axios.delete(
      `${config.backend}/follow/${course?.id}/${student?.userId}/`
    );
    setResetCourseTable(newUid(20));
  };

  return (
    <div className="max-w-6xl flex-col pb-8">
      {isMobile && <MobileSubPageMenu to={-1} />}
      <BreadCrumbsDetails
        prevPathname={basePath}
        prevName={t('breadcrumbs.USERS')}
        pathname={window.location.pathname}
        name={student.username}
      />
      <div className="pb-2 md:pt-6">
        {isMobile ? (
          <div className="flex w-full flex-col gap-4">
            <div className="flex items-center">
              <PersonAvatar
                inline
                id={student.id}
                name={student.username}
                imageSrc={student.picture}
              ></PersonAvatar>
              <h1 className="break-all pb-1.5 text-lg font-semibold text-black sm:text-xl">
                {student.username}
              </h1>
            </div>

            <div className="flex w-full flex-col justify-between gap-4 xl:mx-4 xl:flex-row">
              <div className="flex flex-col content-center">
                <div className="flex flex-wrap content-center text-xs text-[#919193]">
                  <p className="mr-2 border-r border-[#919193] pr-2">
                    {t(parseRole(student.role))}
                  </p>
                  <span>
                    <Link
                      className="inline-block pr-2 text-xs text-tint-blue hover:underline"
                      to="../#"
                    >
                      {student.email}
                    </Link>
                  </span>
                </div>
              </div>

              <div className="flex flex-wrap items-center gap-3">
                <div
                  className={`${
                    hints?.id == 'hint_16' && 'active-hint-parent'
                  }`}
                >
                  <Button
                    variant="outline"
                    size="md"
                    containsOnlyIcon={true}
                    className="relative"
                    onClick={async () => {
                      if (isFollow) {
                        await axios.delete(
                          `${config.backend}/trackuser/${auth?.user?.id}/${student.id}`
                        );
                        setIsFollow(!isFollow);
                      } else {
                        await axios.post(`${config.backend}/trackusers`, {
                          userId: auth?.user?.id,
                          studentId: student.id,
                        });
                        setIsFollow(!isFollow);
                      }
                    }}
                  >
                    <Hint
                      key={`hint_16`}
                      id={'hint_16'}
                      leftDots={'-left-2 leading-[26px] top-1.5'}
                      title={t('hint.title_16')}
                      order={16}
                      style={{
                        right: '-10px',
                        top: '60px',
                      }}
                    />
                    {isFollow ? (
                      <img
                        src="/images/components/follow_up_courses/star_icon.svg"
                        alt="star_icon"
                        className="h-5"
                      />
                    ) : (
                      <img
                        src="/images/components/follow_up_courses/star_white.svg"
                        alt="star_icon"
                        className="h-5"
                      />
                    )}
                  </Button>
                </div>

                <>
                  {Math.max(
                    authUser?.role || 0,
                    authUser?.activeOrganisationRole || 0
                  ) >= 90 && (
                    <div>
                      <Button
                        onClick={() => {
                          navigate(
                            `/${i18n.language}/manage/${organisationId}/users/${userId}`
                          );
                        }}
                        variant="outline"
                        size="md"
                        className="flex items-center"
                      >
                        {t('pages.follow_up_users.manage_user')}
                        <ArrowRight className="ml-2 h-5 w-5" />
                      </Button>
                    </div>
                  )}

                  <div
                    className={`${
                      hints?.id == 'hint_17' && 'active-hint-parent'
                    }`}
                  >
                    <Button
                      onClick={() => {
                        document.body.style.overflow = 'hidden';
                        setIsOpenAddContentModal(true);
                      }}
                      size="md"
                      className="relative"
                    >
                      <Hint
                        key="hint_17"
                        id="hint_17"
                        leftDots="-left-2 leading-[26px] top-1.5"
                        title={t('hint.title_17')}
                        order={17}
                        style={{
                          right: '-10px',
                          top: '60px',
                        }}
                      />
                      {t('pages.follow_up_users.add_to_content')}
                    </Button>
                  </div>
                </>
              </div>
            </div>
          </div>
        ) : (
          <PageHeader /* @ts-expect-error eslint-disable-next-line */
            to={-1}
            ariaLabel={'placeholder'}
          >
            <div className="flex w-full items-center">
              <div className="flex items-center">
                <PersonAvatar
                  inline
                  id={student.id}
                  name={student.username}
                  imageSrc={student.picture}
                ></PersonAvatar>
              </div>

              <div className="mx-2 flex w-full flex-col justify-between gap-4 xl:mx-4 xl:flex-row">
                <div className="flex flex-col content-center">
                  <h1 className="break-all pb-1.5 text-lg font-semibold text-black sm:text-xl">
                    {student.username}
                  </h1>
                  <div className="flex flex-wrap content-center text-xs text-[#919193]">
                    <p className="mr-2 border-r border-[#919193] pr-2">
                      {t(parseRole(student.role))}
                    </p>
                    <span>
                      <Link
                        className="inline-block pr-2 text-xs text-tint-blue hover:underline"
                        to="../#"
                      >
                        {student.email}
                      </Link>
                    </span>
                  </div>
                </div>

                <div className="flex flex-wrap items-center gap-3">
                  <div
                    className={`${
                      hints?.id == 'hint_16' && 'active-hint-parent'
                    }`}
                  >
                    <Button
                      variant="outline"
                      size="md"
                      containsOnlyIcon={true}
                      className="relative"
                      onClick={async () => {
                        if (isFollow) {
                          await axios.delete(
                            `${config.backend}/trackuser/${auth?.user?.id}/${student.id}`
                          );
                          setIsFollow(!isFollow);
                        } else {
                          await axios.post(`${config.backend}/trackusers`, {
                            userId: auth?.user?.id,
                            studentId: student.id,
                          });
                          setIsFollow(!isFollow);
                        }
                      }}
                    >
                      <Hint
                        key={`hint_16`}
                        id={'hint_16'}
                        leftDots={'-left-2 leading-[26px] top-1.5'}
                        title={t('hint.title_16')}
                        order={16}
                        style={{
                          right: '-10px',
                          top: '60px',
                        }}
                      />
                      {isFollow ? (
                        <img
                          src="/images/components/follow_up_courses/star_icon.svg"
                          alt="star_icon"
                          className="h-5"
                        />
                      ) : (
                        <img
                          src="/images/components/follow_up_courses/star_white.svg"
                          alt="star_icon"
                          className="h-5"
                        />
                      )}
                    </Button>
                  </div>

                  <>
                    {Math.max(
                      authUser?.role || 0,
                      authUser?.activeOrganisationRole || 0
                    ) >= 90 && (
                      <div>
                        <Button
                          onClick={() => {
                            navigate(
                              `/${i18n.language}/manage/${organisationId}/users/${userId}`
                            );
                          }}
                          variant="outline"
                          size="md"
                          className="flex items-center"
                        >
                          {t('pages.follow_up_users.manage_user')}
                          <ArrowRight className="ml-2 h-5 w-5" />
                        </Button>
                      </div>
                    )}

                    <div
                      className={`${
                        hints?.id == 'hint_17' && 'active-hint-parent'
                      }`}
                    >
                      <Button
                        onClick={() => {
                          document.body.style.overflow = 'hidden';
                          setIsOpenAddContentModal(true);
                        }}
                        size="md"
                        className="relative"
                      >
                        <Hint
                          key="hint_17"
                          id="hint_17"
                          leftDots="-left-2 leading-[26px] top-1.5"
                          title={t('hint.title_17')}
                          order={17}
                          style={{
                            right: '-10px',
                            top: '60px',
                          }}
                        />
                        {t('pages.follow_up_users.add_to_content')}
                      </Button>
                    </div>
                  </>
                </div>
              </div>
            </div>
          </PageHeader>
        )}

        <div className="mt-6 mb-2 flex">
          <p>{t('pages.follow_up_users.teams')}</p>

          <div className="ml-2">
            <Tag title={student.teamNames?.join(', ')} size="md" />
          </div>
        </div>
      </div>
      <div className="mb-6 mt-3">
        <Tabs activeName={tab} onChange={(tab) => setTab(tab)}>
          <div className="flex flex-row gap-3">
            <Tabs.TabButton name="courses">
              {t('pages.follow_up_users.courses')}
              <span className="ml-2 text-base text-[#919193]">
                {student?.nrOfMemberCourses ? student?.nrOfMemberCourses : 0}
              </span>
              <span
                aria-hidden="true"
                className={`ml-2 inline-block h-2 w-2 shrink-0 rounded-full bg-[#fc6232] ${
                  tab === 'courses' ? 'visible' : 'invisible'
                }`}
              ></span>
            </Tabs.TabButton>
            {authUser?.useLp && (
              <Tabs.TabButton name="learningpaths">
                {t('courseTypes.learning-paths')}
                <span className="ml-2 text-base text-[#919193]">
                  {student?.nrOfMemberLearningPaths}
                </span>
              </Tabs.TabButton>
            )}
          </div>
        </Tabs>
      </div>
      {tab === 'courses' && (
        <>
          <div className="flex w-full flex-col justify-between lg:flex-row lg:items-center">
            <div className="pb-4 pt-2 md:w-1/2 xl:w-1/3">
              <InputText
                value={courseInpFilter}
                onChange={(ev) => setCourseInpFilter(ev.target.value)}
                Icon={Search}
                placeholder={t('search.course')}
              />
            </div>
            {(selectedCourses?.size > 0 || deselectCourses) && (
              <div className="mt-6 flex flex-row items-center gap-2 lg:mt-0">
                <OptionsAction
                  menuItems={filteredBulkReportMenuItems}
                  rowInfo={{}}
                  positionDropdown={true}
                  styleDropdown={{
                    top: '30px',
                    left: 'auto',
                    right: '0',
                  }}
                />
              </div>
            )}
          </div>

          <div className="z-[21] flex flex-col pb-4 sm:flex-row">
            <span className="pr-2">
              <FilterList
                filters={FILTERS_STATUS}
                onSelect={setSelectedStatus}
                selected={selectedStatus}
              />
            </span>
            <span className="z-[2] pr-2 pt-2 sm:pt-0">
              <FilterDropdown
                clearButtonLabel="clear"
                onChange={(value: any) => {
                  setCoursesType(value);
                  setResetCourseTable(newUid(20));
                }}
                buttonText={`${t('pages.follow_up.course_type')}`}
                options={courseTypeData}
                value={coursesType}
                dropdownPositionMobileRight={true}
              />
            </span>
          </div>

          <DataTable
            filter={courseInpFilter}
            key={resetCourseTable}
            setContentRange={setContentRange}
            rowPath={(course) => `${coursePath}/${course.id}`}
            selectable={{
              selected: selectedCourses,
              setSelected: setSelectedCourses,
              deselect: deselectCourses,
              setDeselect: setDeselectCourses,
              checkboxIconMobileType: 'circle',
            }}
            defaultSort={[
              { id: 'updatedAt', desc: false },
              { id: 'courseName', desc: false },
            ]}
            fetch={useGet.bind(null, followedCoursePath, followedCourseParams)}
            empty={{
              template: 2,
              text: t('empty_tenplate.course_list'),
              btn_text: t('pages.follow_up_users.add_to_content'),
              btnClick: () => setIsOpenAddContentModal(true),
              // btn_path: userPath,
            }}
            screensUpdateTable="desktop"
            columns={[
              {
                title: t('columns.courseName'),
                id: 'courseName',
                className: 'col-start-1 col-end-9',
                render: (course: any) => (
                  <div className="flex items-center">
                    <div className="mr-3 w-16 min-w-16 sm:w-20 sm:min-w-20">
                      <img
                        src={
                          course?.courseImage ||
                          course?.image ||
                          '/images/courseFallback.png'
                        }
                        alt={course.courseName || course.name}
                        className="inline h-12 w-full rounded-lg object-cover sm:h-14"
                      />
                    </div>
                    <div className="ml-3 flex flex-col">
                      <p className="text-xs text-[#919193]">
                        {t(`courseTypes.${course?.courseType}`)}
                      </p>
                      {course.progress > 0.99 ? (
                        <div className="break-all font-medium text-[#919193]">
                          {course.courseName || course.name}
                        </div>
                      ) : (
                        <div className="break-all font-medium">
                          {course.courseName || course.name}
                        </div>
                      )}
                    </div>
                  </div>
                ),
              },
              {
                addTitleOnMobile: true,
                className: 'col-start-1 col-end-4 row-start-2',
                id: 'followsCreatedAt',
                title: t('columns.added'),
                align: 'right',
                render: (course: any) => (
                  <div>
                    {course.progress > 0.99 ? (
                      <div className="text-[#919193]">
                        <div>
                          {format(
                            new Date(course.followsCreatedAt),
                            'dd/MM/yyyy'
                          )}
                        </div>
                        {/* to do: add team info */}
                        {/* <div className="text-xs font-normal text-[#7d7d81]">
                        Onderhoud groep A
                      </div> */}
                      </div>
                    ) : (
                      <div>
                        <div>
                          {format(
                            new Date(course.followsCreatedAt),
                            'dd/MM/yyyy'
                          )}
                        </div>
                        {/* to do: add team info */}
                        {/* <div className="text-xs font-normal text-[#7d7d81]">
                        Onderhoud groep A
                      </div> */}
                      </div>
                    )}
                  </div>
                ),
              },
              {
                id: 'startDate',
                title: t('columns.started'),
                align: 'right',
                addTitleOnMobile: true,
                className:
                  'col-start-4 col-end-7 row-start-2 justify-center text-center',
                render: (course: any) =>
                  course.progress === 0 ? (
                    <p className="text-[#fc6232]">
                      {t('pages.follow_up_users.not_started_yet')}
                    </p>
                  ) : (
                    <div>
                      {course.progress > 0.99 ? (
                        <div className="text-[#919193]">
                          {format(new Date(course.startDate), 'dd/MM/yyyy')}
                        </div>
                      ) : (
                        <div>
                          {format(new Date(course.startDate), 'dd/MM/yyyy')}
                        </div>
                      )}
                    </div>
                  ),
              },
              {
                id: 'followsUpdatedAt',
                title: t('columns.last_activity'),
                align: 'right',
                addTitleOnMobile: true,
                className:
                  'col-start-7 col-end-10 row-start-2 text-right justify-end',
                render: (course: any) =>
                  course.progress === 0 ? (
                    <p>-</p>
                  ) : (
                    <div>
                      {course.progress > 0.99 ? (
                        <div className="text-[#919193]">
                          {format(
                            new Date(course.followsUpdatedAt || course.endDate),
                            'dd/MM/yyyy'
                          )}
                        </div>
                      ) : (
                        <div>
                          {format(
                            new Date(course.followsUpdatedAt || course.endDate),
                            'dd/MM/yyyy'
                          )}
                        </div>
                      )}
                    </div>
                  ),
              },
              {
                addTitleOnMobile: true,
                className: 'col-start-1 col-end-4 row-start-3',
                id: 'progress',
                title: t('columns.progress'),
                align: 'right',
                render: (course: any) => (
                  <div>
                    {course.progress > 0.99 ? (
                      <div className="text-[#919193]">
                        {Math.round(course.progress * 100)}%
                      </div>
                    ) : (
                      <div>{Math.round(course.progress * 100)}%</div>
                    )}
                  </div>
                ),
              },
              {
                addTitleOnMobile: true,
                className:
                  'col-start-4 col-end-7 row-start-3 justify-center text-center',
                id: 'scoreRatio',
                title: t('columns.score'),
                align: 'right',
                render: (course: any) => (
                  <div>
                    {!course?.maxScore ? (
                      <Tag
                        size="sm"
                        variant="success"
                        title={t('pages.follow_up_courses.score_status')}
                      ></Tag>
                    ) : (
                      <span
                        className={`${
                          +toPercent(course.score, course.maxScore) < 50
                            ? 'text-error-05'
                            : +toPercent(course.score, course.maxScore) > 49 &&
                              +toPercent(course.score, course.maxScore) <
                                course?.minScore * 100
                            ? 'text-warning-04'
                            : 'text-success-05'
                        }`}
                      >
                        {toPercent(course.score, course.maxScore)
                          ? toPercent(course.score, course.maxScore)
                          : 0}
                        % ({round2(course.score ? course.score : 0)}/
                        {round2(course.maxScore)})
                      </span>
                    )}
                  </div>
                ),
              },
              {
                id: 'actionButton',
                sortable: false,
                title: '',
                className: 'col-start-9 row-start-1 justify-end',
                render: (course: any) => (
                  <OptionsAction
                    fnClick={() => {
                      setIsMergeActive(false);
                      setMergeContent([]);
                      handleCourseMerge(course);
                    }}
                    menuItems={[
                      {
                        id: '1',
                        title: t('pages.follow_up_users.share_settings'),
                        onClick: (ev) => {
                          const resultPath = `/${i18n.language}/follow-up/${organisationId}/result/${course?.id}/${student?.userId}/lesson`;
                          navigate(resultPath + '?details=user');
                        },
                      },
                      {
                        id: 'reports',
                        addOnMobile: true,
                        title: t('pages.follow_up_courses.reports', {
                          defaultValue: 'Reports',
                        }),
                        hidden: course?.courseType === 'instruction',
                        children: [
                          {
                            id: '2_detailed_course_report',
                            title: t('report.courseOverviewDetailed'),
                            onClick: () => {
                              openCourseReportModal(course, {
                                formType: 'courseOverview',
                                noCompetences: true,
                              });
                            },
                          },
                          {
                            id: '3_detailed_competence_report',
                            title: t(
                              'report.courseOverviewDetailedCompetences'
                            ),
                            onClick: () => {
                              openCourseReportModal(course, {
                                formType: 'courseOverview',
                              });
                            },
                          },
                          {
                            id: '4_course_report',
                            title: t('report.courseOverview'),
                            onClick: () => {
                              openCourseReportModal(course, {
                                formType: 'courseOverview',
                                ...compactCourseReportOptions(course),
                              });
                            },
                          },
                          {
                            id: '5_competence_report',
                            title: t('report.courseOverviewCompetences'),
                            onClick: () => {
                              openCourseReportModal(course, {
                                formType: 'courseOverview',
                                ...compactCourseReportOptions(course),
                              });
                            },
                          },
                          ...(useCertificates
                            ? [
                                {
                                  id: '6',
                                  title: t(
                                    'pages.follow_up_courses.download_certificate'
                                  ),
                                  onClick: async () => {
                                    const promises = [];
                                    const link = `${config.teoreport}/report/?lang=${i18n.language}`;
                                    promises.push(
                                      axios.post(link, {
                                        download: true,
                                        lang: i18n.language,
                                        userId: student.id,
                                        formType: 'certificate',
                                        courseId: course.courseId,
                                        organisationId: organisationId,
                                      })
                                    );

                                    Promise.allSettled(promises).then(
                                      (results: any) => {
                                        results[0]?.value?.data?.link &&
                                          downloadPDFLink(
                                            results[0]?.value?.data?.link
                                          );
                                      }
                                    );
                                    setShowNotification({
                                      message: t(
                                        'pages.report_page.report_download_message'
                                      ),
                                      delay: 5000,
                                    });
                                  },
                                },
                              ]
                            : []),
                          {
                            id: '7',
                            title: t(
                              'pages.follow_up_courses.download_results'
                            ),
                            onClick: () => {
                              setDownloadReportPayload({
                                lang: i18n.language,
                                userId: student.id,
                                formType: 'exportResults',
                                courseId: course.courseId,
                                organisationId,
                              });

                              setIsOpenDownloadtModal(true);
                            },
                          },
                        ],
                      },
                      {
                        id: '8',
                        addOnMobile: true,
                        itemDelete: true,
                        title: t(
                          'pages.follow_up_users.remove_user_from_course'
                        ),

                        onClick: async () => {
                          setItemDelete(course);
                          setIsOpenDeleteModalCourse(true);
                        },
                      },
                      {
                        addOnMobile: true,
                        disabled: !isMergeActive,
                        itemDelete: true,
                        id: '9',
                        onClick: () => {
                          setMergeCourse(course);
                          setIsOpenMergeModal(true);
                          // IsMergeActive
                        },
                        title: t('pages.follow_up_users.merge_course'),
                      },
                    ]}
                    pageDetail={{
                      title: t('pages.follow_up_users.share_settings'),
                      rowPath: (course) => `${coursePath}/${course.id}`,
                    }}
                    screensUpdateTable="desktop"
                    positionDropdown={true}
                    rowInfo={course}
                    mobileHeader={{
                      render: (course: any) => (
                        <div className="flex items-center">
                          <div className="mr-3 w-16 min-w-16 sm:w-20 sm:min-w-20">
                            <img
                              src={
                                course.courseImage ||
                                '/images/courseFallback.png'
                              }
                              alt={course.name}
                              className="inline h-12 w-full rounded-lg object-cover sm:h-14"
                            />
                          </div>
                          {Math.round(course.progress * 100) === 99 ? (
                            <div className="ml-3 font-medium text-[#919193]">
                              {course.courseName}
                            </div>
                          ) : (
                            <div className="ml-3 font-medium">
                              {course.courseName}
                            </div>
                          )}
                        </div>
                      ),
                    }}
                  />
                ),
              },
            ]}
          />
        </>
      )}
      {tab === 'learningpaths' && (
        <>
          <div className="pb-4 pt-2 md:w-1/2 xl:w-1/3">
            <InputText
              value={lpInpFilter}
              onChange={(ev) => setLpInpFilter(ev.target.value)}
              Icon={Search}
              placeholder={t('search.learningpath')}
            />
          </div>

          <div className="z-[21] flex flex-col pb-4 sm:flex-row">
            <span className="pr-2">
              <FilterList
                filters={FILTERS_STATUS}
                onSelect={setSelectedLpStatus}
                selected={selectedLpStatus}
              />
            </span>
          </div>

          <DataTable
            filter={lpInpFilter}
            key={resetLPTable}
            setContentRange={setContentRange}
            rowPath={(learningpath) => `${lpPath}/${learningpath.lpgroupId}`}
            defaultSort={[
              { id: 'updatedAt', desc: false },
              { id: 'lpName', desc: false },
            ]}
            fetch={useGet.bind(null, '/myfollowedlpgroups', {
              userId: authUser?.id,
              studentId: userId,
              organisationId: organisationId,
              lpStatus: filterLpStatus,
            })}
            empty={{
              template: 2,
              text: t('pages.follow_learningpath.lp_list_empty'),
              btn_text: t('pages.follow_up_users.add_to_content'),
              btnClick: () => setIsOpenAddContentModal(true),
            }}
            screensUpdateTable="desktop"
            columns={[
              {
                title: t('columns.learningpath_name'),
                id: 'lpName',
                className: 'col-start-1 col-end-9',
                render: (learningpath: any) => (
                  <div className="flex items-center">
                    <div className="mr-3 w-16 min-w-16 sm:w-20 sm:min-w-20">
                      <img
                        src={
                          learningpath?.lpgroupPicture ||
                          learningpath?.lpPicture ||
                          '/assets/images/LearnPath.png'
                        }
                        alt={learningpath?.lpName}
                        className="inline h-12 w-full rounded-lg object-cover sm:h-14"
                      />
                    </div>

                    {learningpath.lpProgress > 0.99 ? (
                      <div className="ml-3 break-all font-medium text-[#919193]">
                        {learningpath?.lpgroupName || learningpath?.lpName}
                      </div>
                    ) : (
                      <div className="ml-3 break-all font-medium">
                        {learningpath?.lpgroupName || learningpath?.lpName}
                      </div>
                    )}
                  </div>
                ),
              },
              {
                addTitleOnMobile: true,
                className: 'col-start-1 col-end-4 row-start-2',
                id: 'followsCreatedAt',
                title: t('columns.added'),
                align: 'right',
                render: (learningpath: any) => (
                  <div>
                    {learningpath.lpProgress > 0.99 ? (
                      <div className="text-[#919193]">
                        <div>
                          {format(
                            new Date(learningpath?.followsCreatedAt),
                            'dd/MM/yyyy'
                          )}
                        </div>
                      </div>
                    ) : (
                      <div>
                        <div>
                          {format(
                            new Date(learningpath?.followsCreatedAt),
                            'dd/MM/yyyy'
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                ),
              },
              {
                id: 'startDate',
                title: t('columns.started'),
                align: 'right',
                addTitleOnMobile: true,
                className:
                  'col-start-4 col-end-7 row-start-2 justify-center text-center',
                render: (learningpath: any) =>
                  learningpath.lpProgress === 0 ? (
                    <p className="text-[#fc6232]">
                      {t('pages.follow_up_users.not_started_yet')}
                    </p>
                  ) : (
                    <div>
                      {learningpath.lpProgress > 0.99 ? (
                        <div className="text-[#919193]">
                          {format(
                            new Date(learningpath.lpStartDate),
                            'dd/MM/yyyy'
                          )}
                        </div>
                      ) : (
                        <div>
                          {format(
                            new Date(learningpath.lpStartDate),
                            'dd/MM/yyyy'
                          )}
                        </div>
                      )}
                    </div>
                  ),
              },
              {
                id: 'followsUpdatedAt',
                title: t('columns.last_activity'),
                align: 'right',
                addTitleOnMobile: true,
                className:
                  'col-start-7 col-end-10 row-start-2 text-right justify-end',
                render: (learningpath: any) =>
                  learningpath.lpProgress === 0 ? (
                    <p>-</p>
                  ) : (
                    <div>
                      {learningpath.lpProgress > 0.99 ? (
                        <div className="text-[#919193]">
                          {format(
                            new Date(
                              learningpath.followsUpdatedAt ||
                                learningpath.lpEndDate
                            ),
                            'dd/MM/yyyy'
                          )}
                        </div>
                      ) : (
                        <div>
                          {format(
                            new Date(
                              learningpath.followsUpdatedAt ||
                                learningpath.lpEndDate
                            ),
                            'dd/MM/yyyy'
                          )}
                        </div>
                      )}
                    </div>
                  ),
              },
              {
                addTitleOnMobile: true,
                className: 'col-start-1 col-end-4 row-start-3',
                id: 'progress',
                title: t('columns.progress'),
                align: 'right',
                render: (learningpath: any) => (
                  <div>
                    {learningpath.lpProgress > 0.99 ? (
                      <div className="text-[#919193]">
                        {Math.round(learningpath.lpProgress * 100)}%
                      </div>
                    ) : (
                      <div>{Math.round(learningpath.lpProgress * 100)}%</div>
                    )}
                  </div>
                ),
              },
              {
                addTitleOnMobile: true,
                className:
                  'col-start-4 col-end-7 row-start-3 justify-center text-center',
                id: 'scoreRatio',
                title: t('columns.score'),
                align: 'right',
                render: (learningpath: any) => (
                  <div>
                    {!learningpath?.maxScore ? (
                      <Tag
                        size="sm"
                        variant="success"
                        title={t('pages.follow_up_courses.score_status')}
                      ></Tag>
                    ) : (
                      <span
                        className={`${
                          +toPercent(
                            learningpath.score,
                            learningpath.maxScore
                          ) < 50
                            ? 'text-error-05'
                            : +toPercent(
                                learningpath.score,
                                learningpath.maxScore
                              ) > 49 &&
                              +toPercent(
                                learningpath.score,
                                learningpath.maxScore
                              ) <
                                learningpath?.minScore * 100
                            ? 'text-warning-04'
                            : 'text-success-05'
                        }`}
                      >
                        {toPercent(learningpath.score, learningpath.maxScore)
                          ? toPercent(learningpath.score, learningpath.maxScore)
                          : 0}
                        % ({round2(learningpath.score ? learningpath.score : 0)}
                        /{round2(learningpath.maxScore)})
                      </span>
                    )}
                  </div>
                ),
              },
              {
                id: 'actionButton',
                sortable: false,
                title: '',
                className: 'col-start-9 row-start-1 justify-end',
                render: (learningpath: any) => (
                  <OptionsAction
                    menuItems={[
                      {
                        id: '1',
                        addOnMobile: true,
                        title: t('pages.follow_up_users.view_correction'),
                        onClick: (ev) => {
                          const resultPath = `/${i18n.language}/follow-up/${organisationId}/learning-paths/correction/${learningpath?.lpgroupId}/${student?.userId}`;
                          navigate(resultPath);
                        },
                      },
                      {
                        id: 'reports',
                        addOnMobile: true,
                        title: t('pages.follow_up_courses.reports', {
                          defaultValue: 'Reports',
                        }),
                        children: [
                          {
                            id: '4_detailed_lp_report',
                            title: t('report.lpOverviewDetailed'),
                            onClick: () => {
                              openLpReportModal(learningpath, {
                                formType: 'lpOverview',
                                noCompetences: true,
                              });
                            },
                          },
                          {
                            id: '5_detailed_competence_lp_report',
                            title: t(
                              'report.courseOverviewDetailedCompetences'
                            ),
                            onClick: () => {
                              openLpReportModal(learningpath, {
                                formType: 'lpOverview',
                              });
                            },
                          },
                          {
                            id: '6_lp_report',
                            title: t('report.lpOverview'),
                            onClick: () => {
                              openLpReportModal(learningpath, {
                                formType: 'lpOverview',
                                noCompetences: true,
                                noBirth: true,
                                noDiploma: true,
                                noNodes: true,
                              });
                            },
                          },
                          {
                            id: '7_competence_lp_report',
                            title: t('report.courseOverviewCompetences'),
                            onClick: () => {
                              openLpReportModal(learningpath, {
                                formType: 'lpOverview',
                                noBirth: true,
                                noDiploma: true,
                                noNodes: true,
                              });
                            },
                          },
                        ],
                      },
                      {
                        addOnMobile: true,
                        itemDelete: true,
                        id: '3',
                        onClick: () => {
                          setIsOpenDeleteModal(true);
                          setLpDelete(learningpath);
                        },

                        title: t('pages.follow_up_users.remove_user_from_lp'),
                      },
                    ]}
                    // pageDetail={{
                    //   title: t('pages.follow_up_users.view_correction'),
                    //   rowPath: (learningpath) =>
                    //     `${lpPath}/${learningpath.lpgroupId}`,
                    // }}
                    screensUpdateTable="desktop"
                    rowInfo={learningpath}
                    mobileHeader={{
                      render: (learningpath: any) => (
                        <div className="flex items-center">
                          <div className="mr-3 w-16 min-w-16 sm:w-20 sm:min-w-20">
                            <img
                              src={
                                learningpath.lpPicture ||
                                '/images/courseFallback.png'
                              }
                              alt={learningpath.lpName}
                              className="inline h-12 w-full rounded-lg object-cover sm:h-14"
                            />
                          </div>
                          {Math.round(learningpath.lpProgress * 100) === 99 ? (
                            <div className="ml-3 font-medium text-[#919193]">
                              {learningpath.lpName}
                            </div>
                          ) : (
                            <div className="ml-3 font-medium">
                              {learningpath.lpName}
                            </div>
                          )}
                        </div>
                      ),
                    }}
                  />
                ),
              },
            ]}
          />
        </>
      )}

      {isOpenDeleteModal && (
        <ComponentDeleteModal
          closeModal={() => setIsOpenDeleteModal(false)}
          setIsOpenDeleteModal={setIsOpenDeleteModal}
          title={t('delete_modal.title_user') + student.username}
          heading={t('delete_modal.heading_user')}
          text={t('delete_modal.text_user_lp')}
          handleDelete={() => handleDeleteUser(lpDelete)}
        />
      )}
      {isOpenMergeModal && mergeCourse && isMergeActive && (
        <MergeModal
          closeModal={() => setIsOpenMergeModal(false)}
          setIsOpenDeleteModal={setIsOpenMergeModal}
          setMergeCourse={setMergeCourse}
          course={mergeCourse}
          mergeContent={mergeContent}
          setResetCourseTable={setResetCourseTable}
          userId={student.id}
        />
      )}
      {isOpenDownloadtModal && downloadReportPayload && (
        <DownloadReportModal
          report="courses"
          closeModal={() => {
            setIsOpenDownloadtModal(false);
            setDownloadReportPayload(null);
          }}
          setIsOpenDownloadtModal={(open: boolean) => {
            setIsOpenDownloadtModal(open);

            if (!open) {
              setDownloadReportPayload(null);
            }
          }}
          stateReport={undefined}
          user={auth?.user}
          updateStateReport={undefined}
          allSelect={undefined}
          courseType={courseType}
          reportPayload={downloadReportPayload}
          reportUrl={`${config.teoreport}/report/?lang=${i18n.language}`}
          downloadFn={downloadPDFLink}
          resetSelection={false}
        />
      )}
      {isOpenDownloadReportModal && payloadDownload && (
        <ReportDownloadModal
          user={auth?.user}
          closeModal={() => {
            setIsOpenDownloadtReportModal(false);
            setPayloadDownload(null);
          }}
          payloadDownload={payloadDownload}
          courseId={null}
          lpgroupId={null}
          organisationId={organisationId}
        />
      )}
      {isOpenDeleteModalCourse && (
        <DeleteModalFollow
          closeModal={() => setIsOpenDeleteModalCourse(false)}
          setIsOpenDeleteModal={setIsOpenDeleteModalCourse}
          title={`${t('delete_modal.title_course')}${
            itemDelete.courseName || itemDelete.name || ''
          }`}
          heading={t('delete_modal.heading_course_fl')}
          text={t('delete_modal.text_course_fl')}
          onConfirm={() => deleteCourse(itemDelete)}
        />
      )}
    </div>
  );
}

export default UserDetailsPage;
